import { removeWindowClass } from '@app/utils/helpers';
// import { Gatekeeper } from 'gatekeeper-client-sdk';
import {BASE_URL} from '../config'
import { fetch } from '@app/apiFunction';


export const getAllCategoryName = async () => {
    const token = localStorage.getItem('token');
    const url = BASE_URL+'/category/get-all-categories'
    const type = "get"
    const resp = fetch(url, type, null, token)
    return resp;
  };